var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "sh": "Contact US",
            "bg": "/images/form/contact/visual.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('sub-section', {
    staticClass: "page-section--first page-section--last"
  }, [_c('p', {
    staticClass: "page-text text-right mb-16 mb-lg-20"
  }, [_c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")]), _vm._v(" 필수입력 항목입니다.")]), _c('v-sheet', {
    staticClass: "form-table"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "font-size-18 font-weight-medium",
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "width": "116"
    }
  }, [_vm._v("회사명 "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "hide-details": "auto",
      "placeholder": "회사명을 입력하세요."
    },
    model: {
      value: _vm.form.companyName,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "companyName", $$v);
      },
      expression: "form.companyName"
    }
  })], 1)], 1), _c('v-divider', {
    staticClass: "my-12"
  }), _c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "font-size-18 font-weight-medium",
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "width": "116"
    }
  }, [_vm._v("담당자명 "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "hide-details": "auto",
      "placeholder": "담당자명을 입력하세요."
    },
    model: {
      value: _vm.form.manager,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "manager", $$v);
      },
      expression: "form.manager"
    }
  })], 1)], 1), _c('v-divider', {
    staticClass: "my-12"
  }), _c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "font-size-18 font-weight-medium",
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "width": "116"
    }
  }, [_vm._v("연락처 "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "hide-details": "auto",
      "placeholder": "연락받으실 연락처를 입력하세요."
    },
    model: {
      value: _vm.form.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "phone", $$v);
      },
      expression: "form.phone"
    }
  })], 1)], 1), _c('v-divider', {
    staticClass: "my-12"
  }), _c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "font-size-18 font-weight-medium",
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "width": "116"
    }
  }, [_vm._v("이메일 "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-text-field', {
    attrs: {
      "outlined": "",
      "hide-details": "auto",
      "placeholder": "이메일을 입력하세요."
    },
    model: {
      value: _vm.email1,
      callback: function callback($$v) {
        _vm.email1 = $$v;
      },
      expression: "email1"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-combobox', {
    attrs: {
      "outlined": "",
      "hide-details": "auto",
      "prefix": "@",
      "items": _vm.emailItems
    },
    model: {
      value: _vm.email2,
      callback: function callback($$v) {
        _vm.email2 = $$v;
      },
      expression: "email2"
    }
  })], 1)], 1)], 1)], 1), _c('v-divider', {
    staticClass: "my-12"
  }), _c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "font-size-18 font-weight-medium",
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "width": "116"
    }
  }, [_vm._v("내용 "), _c('span', {
    staticClass: "red--text"
  }, [_vm._v("*")])])], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "height": "334",
      "outlined": "",
      "hide-details": "auto",
      "placeholder": "내용을 입력하세요"
    },
    model: {
      value: _vm.form.content,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "content", $$v);
      },
      expression: "form.content"
    }
  })], 1)], 1), _c('v-divider', {
    staticClass: "my-12"
  })], 1), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    },
    on: {
      "click": function click($event) {
        return _vm.$rotuer.push('/ko');
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "large": "",
      "outlined": "",
      "color": "grey",
      "min-width": "200"
    }
  }, [_vm._v("취소")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('v-btn', {
    attrs: {
      "large": "",
      "color": "primary",
      "min-width": "200"
    }
  }, [_vm._v("작성완료")])], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }